import React, { useEffect, useState } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, message, Tooltip, Space } from "antd";
import { FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import getDetalleVisitaPorTipo from "../../../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import obtenerCategoriasProductos from "../../../../services/visitas_tecnicas/getCategoriaProductosService";
import { useSelector } from "react-redux";
import normalizarCoordenada from "../../../../utils/normalizarGeoreferencias";

const Export_analisisCapacidades = () => {
  const [dataCompleta, setDataCompleta] = useState([]);
  const [dataCategoriasxproducto, setDataCategoriasxproducto] = useState([]);
  const [loading, setLoading] = useState(false); // Estado de carga
  const [loadingExcel, setLoadingExcel] = useState(false); // Estado para Excel
  const [loadingJson, setLoadingJson] = useState(false); // Estado para JSON
  const usernameFromState = useSelector((state) => state.auth.user);

  const fetchDetalleVisitas = async () => {
    try {
      const response = await getDetalleVisitaPorTipo(
        3,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        setDataCompleta(results);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch detalle visitas data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
    }
  };

  function groupByLineaProductiva(datos) {
    return datos.reduce((acc, item) => {
      const { lineaProductiva } = item.detalle;

      if (!acc[lineaProductiva]) {
        acc[lineaProductiva] = [];
      }

      acc[lineaProductiva].push(item);
      return acc;
    }, {});
  }

  const cargarCategoriasYProductos = async (data) => {
    try {
      const response = await obtenerCategoriasProductos();
      if (response.success) {
        setDataCategoriasxproducto(response);
      } else {
        setDataCategoriasxproducto([]);

        console.error(
          "Error al cargar categorías y productos:",
          response.message
        );
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const obtenerDescribcionesCategoriasYproductos = async (data) => {
    if (dataCategoriasxproducto) {
      // Extraer categorías y productos en mapas para acceso rápido
      const categoriaMap = new Map(
        dataCategoriasxproducto.categorias.map((cat) => [cat.id, cat.nombre])
      );
      const productoMap = new Map(
        dataCategoriasxproducto.productos.map((prod) => [prod.id, prod.nombre])
      );

      // Verificar que `lista_productos_fortalecimiento_economico` sea un array antes de hacer `.map()`
      if (Array.isArray(data)) {
        const listaFormateada = data.map((item) => ({
          categoria: categoriaMap.get(item.categoria) || "Desconocido",
          productos: Array.isArray(item.producto)
            ? item.producto.map(
                (id) => productoMap.get(id) || "Producto Desconocido"
              )
            : [],
        }));

        return listaFormateada;
      } else {
        return [];
      }
    } else {
      console.error("Error al cargar categorías y productos:");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchDetalleVisitas(), cargarCategoriasYProductos()]);
      setLoading(false);
    };

    fetchData();
  }, []);
  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }

      setLoadingExcel(true);
      const workbook = new ExcelJS.Workbook();

      // Cargar la plantilla de Excel
      const templateResponse = await fetch(
        "/assets/plantilla_diagnostico_parte2.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();

      await workbook.xlsx.load(templateBuffer);

      const calificaciones = ["Muy Bajo", "Bajo", "Medio", "Alto", "Muy Alto"];

      function obtenerDescripcionCalificacion(calificacion) {
        return calificacion
          ? calificaciones[calificacion - 1] || "Sin evidencia"
          : "Sin evidencia";
      }

      function asignarCalificaciones(
        worksheet,
        currentRow,
        calificacionesObj,
        columnas,
        keys
      ) {
        if (!calificacionesObj || !Array.isArray(keys)) return; // Validación para evitar errores
        keys.forEach((key, index) => {
          const valor = calificacionesObj?.[key]?.valor;
          worksheet.getCell(`${columnas[index]}${currentRow}`).value =
            obtenerDescripcionCalificacion(valor);
        });
      }

      function llenarColumnasComunes(worksheet, item, currentRow) {
        // Paso 1
        worksheet.getCell(`A${currentRow}`).value =
          item.detalle.id_participante || "";
        worksheet.getCell(`B${currentRow}`).value =
          item.detalle.modalidad_visita || "";
        worksheet.getCell(`C${currentRow}`).value =
          item.detalle.lugar_visita || "";
        worksheet.getCell(`D${currentRow}`).value =
          normalizarCoordenada(item.detalle.latuser) ?? "";
        worksheet.getCell(`E${currentRow}`).value =
          normalizarCoordenada(item.detalle.lnguser) ?? "";

        // Paso 2
        worksheet.getCell(`F${currentRow}`).value =
          item.detalle.quien_responde || "";
        worksheet.getCell(`G${currentRow}`).value =
          item.detalle.otro_quien_responde || "";
        worksheet.getCell(`H${currentRow}`).value =
          item.detalle.delegado_presenta_documento_pertinente || "";
        worksheet.getCell(`I${currentRow}`).value =
          item.detalle.nombre_persona || "";
        worksheet.getCell(`J${currentRow}`).value =
          item.detalle.nombre_identitario || "";
        worksheet.getCell(`K${currentRow}`).value =
          item.detalle.rango_edad || "";
        worksheet.getCell(`L${currentRow}`).value = item.detalle.genero || "";
        worksheet.getCell(`M${currentRow}`).value =
          item.detalle.estado_embarazo || "";
        worksheet.getCell(`N${currentRow}`).value =
          item.detalle.nivel_escolaridad || "";
        worksheet.getCell(`O${currentRow}`).value =
          item.detalle.grupo_etnico || "";
        worksheet.getCell(`P${currentRow}`).value =
          item.detalle.lengua_nativa || "";
        worksheet.getCell(`Q${currentRow}`).value =
          item.detalle.lengua_nativa_no || "";
        worksheet.getCell(`R${currentRow}`).value =
          item.detalle.discapacidad || "";
        worksheet.getCell(`S${currentRow}`).value =
          item.detalle.tipo_discapacidad || "";
        worksheet.getCell(`T${currentRow}`).value =
          item.detalle.habilidades_lectoescritoras || "";
        worksheet.getCell(`U${currentRow}`).value =
          item.detalle.traductor_acompanante || "";
        worksheet.getCell(`V${currentRow}`).value =
          item.detalle.afiliacion?.join(", ") || "";
        worksheet.getCell(`W${currentRow}`).value =
          item.detalle.convive_actualmente?.join(", ") || "";
        worksheet.getCell(`X${currentRow}`).value =
          item.detalle.otro_convive_actualmente || "";
        worksheet.getCell(`Y${currentRow}`).value =
          item.detalle.horas_actividad_cuidado || "";
        worksheet.getCell(`Z${currentRow}`).value =
          item.detalle.vive_mismo_lugar_emprendimiento || "";

        // Paso 3
        worksheet.getCell(`AA${currentRow}`).value =
          item.detalle.nombreProyecto || "";
        worksheet.getCell(`AB${currentRow}`).value =
          item.detalle.codigoPreIni || "";
        worksheet.getCell(`AC${currentRow}`).value =
          item.detalle.tipoProyecto || "";
        worksheet.getCell(`AD${currentRow}`).value =
          item.detalle.estadoProyecto || "";
        worksheet.getCell(`AE${currentRow}`).value =
          item.detalle.lineaProductiva || "";
        worksheet.getCell(`AF${currentRow}`).value =
          item.detalle.cambioLineaProductiva || "";
        worksheet.getCell(`AG${currentRow}`).value =
          item.detalle.documento_avala_cambio_diligenciado || "";
        worksheet.getCell(`AH${currentRow}`).value =
          item.detalle.tenenciaPredio || "";
        worksheet.getCell(`AI${currentRow}`).value =
          item.detalle.otraTenenciaPredio || "";
        worksheet.getCell(`AJ${currentRow}`).value =
          item.detalle.areaPredio || "";
        worksheet.getCell(`AK${currentRow}`).value =
          item.detalle.zonaPredio || "";

        // Paso 4
        worksheet.getCell(`AL${currentRow}`).value =
          item.detalle.socios_claves || "";
        worksheet.getCell(`AM${currentRow}`).value =
          item.detalle.otra_socio_clave || "";
        worksheet.getCell(`AN${currentRow}`).value =
          item.detalle.riesgos_desarrollo_negocio?.join(", ") || "";
        worksheet.getCell(`AO${currentRow}`).value =
          item.detalle.otro_riesgos_desarrollo_negocio || "";
        worksheet.getCell(`AP${currentRow}`).value =
          item.detalle.otras_fuentes_ingreso || "";
        worksheet.getCell(`AQ${currentRow}`).value =
          item.detalle.cuales_fuentes_ingreso || "";
        worksheet.getCell(`AR${currentRow}`).value =
          item.detalle.mayor_reto_unidad_productiva || "";
        worksheet.getCell(`AS${currentRow}`).value =
          item.detalle.acceso_recursos || "";
        worksheet.getCell(`AT${currentRow}`).value =
          item.detalle.cuales_acceso_recursos || "";

        // Capacidades Socio-Empresarial
        const calificacionesKeys = [
          "1.1",
          "2.1",
          "2.2",
          "2.3",
          "3.1",
          "3.2",
          "3.3",
          "3.4",
          "3.5",
          "4.1",
        ];
        const columnas = [
          "AU",
          "AV",
          "AW",
          "AX",
          "AY",
          "AZ",
          "BA",
          "BB",
          "BC",
          "BD",
        ];
        asignarCalificaciones(
          worksheet,
          currentRow,
          item?.detalle?.capacidades_socio_empresarial?.calificacion || {},
          columnas,
          calificacionesKeys
        );

        worksheet.getCell(`BE${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.seleccion_indicador?.nombre_indicador?.join(
            ", "
          ) || "";
        worksheet.getCell(`BF${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.acompanamiento_integral?.asociativa?.join(
            ", "
          ) || "";
        worksheet.getCell(`BG${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.acompanamiento_integral?.area_financiera?.join(
            ", "
          ) || "";
        worksheet.getCell(`BH${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.acompanamiento_integral?.area_administrativa?.join(
            ", "
          ) || "";
        worksheet.getCell(`BI${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.acompanamiento_integral?.area_comercial?.join(
            ", "
          ) || "";
        worksheet.getCell(`BJ${currentRow}`).value =
          item?.detalle?.capacidades_socio_empresarial?.acompanamiento_integral?.tics?.join(
            ", "
          ) || "";

        // Paso 5
        worksheet.getCell(`BK${currentRow}`).value =
          item?.detalle?.capacitacion_igualdad_genero || "";
        worksheet.getCell(`BL${currentRow}`).value =
          item?.detalle?.implementado_practicas_equidad_genero || "";
        worksheet.getCell(`BM${currentRow}`).value = Array.isArray(
          item?.detalle?.responsable_acitividades_cuidado_hogar
        )
          ? item.detalle.responsable_acitividades_cuidado_hogar.join(", ")
          : item?.detalle?.responsable_acitividades_cuidado_hogar ?? "";
        worksheet.getCell(`BN${currentRow}`).value =
          item?.detalle?.carga_trabajo_afecta_productividad || "";

        //CAPACIDADES GENERO

        asignarCalificaciones(
          worksheet,
          currentRow,
          item?.detalle?.capacidades_enfoque_transversal?.calificacion || {},
          ["BO", "BP"],
          ["1.1", "1.2"]
        );

        worksheet.getCell(`BQ${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.seleccion_indicador?.nombre_indicador?.join(
            ", "
          ) || "";

        worksheet.getCell(`BR${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.acompanamiento_integral?.participacion_liderazgo_femenino?.join(
            ", "
          ) || "";
        worksheet.getCell(`BS${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.acompanamiento_integral?.gestion_integral_cuidado?.join(
            ", "
          ) || "";
        worksheet.getCell(`BT${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.acompanamiento_integral?.masculinidades_co_responsables_no_violentas?.join(
            ", "
          ) || "";
        worksheet.getCell(`BU${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.acompanamiento_integral?.violencias_basadas_en_genero?.join(
            ", "
          ) || "";
        worksheet.getCell(`BV${currentRow}`).value =
          item?.detalle?.capacidades_enfoque_transversal?.acompanamiento_integral?.derechos_sexuales_y_derechos_reproductivos?.join(
            ", "
          ) || "";
      }

      const procesarHojaAgricola = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }
        let currentRow = 5; // Fila inicial
        for (const item of data) {
          const startRow = currentRow; // Fila de inicio para esta entrada
          let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada

          llenarColumnasComunes(worksheet, item, startRow);

          const agricola = item.detalle.agricola || {};

          worksheet.getCell(`BW${startRow}`).value =
            agricola.area_produccion || "";
          worksheet.getCell(`BX${startRow}`).value = agricola.area_bosque || "";
          worksheet.getCell(`BY${startRow}`).value = agricola.area_predio || "";
          worksheet.getCell(`BZ${startRow}`).value =
            agricola.numero_plantas_sembradas || "";
          worksheet.getCell(`CA${startRow}`).value =
            agricola.distancia_sembrada || "";
          worksheet.getCell(`CB${startRow}`).value =
            agricola.variedad_sembrada || "";
          worksheet.getCell(`CC${startRow}`).value =
            agricola.meses_siembra?.join(", ") || "";
          worksheet.getCell(`CD${startRow}`).value =
            agricola.manejo_registros || "";

          // Comercialización
          const listaComercializacion = agricola.lista_comercializacion || [];
          if (listaComercializacion.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaComercializacion.forEach((comercializacion) => {
              worksheet.getCell(`CE${currentRow}`).value =
                comercializacion.producto || "";
              worksheet.getCell(`CF${currentRow}`).value =
                comercializacion.cantidad_mes_ano || "";
              worksheet.getCell(`CG${currentRow}`).value =
                comercializacion.venta_unidad || "";
              worksheet.getCell(`CH${currentRow}`).value =
                comercializacion.cliente || "";
              currentRow++; // Avanzar fila solo si hay comercialización
            });

            maxRow = Math.max(maxRow, currentRow);
          } else {
            // No hubo comercialización, avanzamos al menos una fila
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //IDENTIFICACIÓN DE TÉCNICAS Y PRÁCTICAS AGRÍCOLAS

          //1. LÍNEA PRODUCTIVA

          const lista_sistema_productivo_tiene =
            agricola.lista_sistema_productivo_tiene || [];
          const listaFiltrada_lista_sistema_productivo_tiene =
            lista_sistema_productivo_tiene.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_sistema_productivo_tiene.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_sistema_productivo_tiene.forEach((item) => {
              worksheet.getCell(`CI${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CJ${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CK${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          worksheet.getCell(`CL${startRow}`).value =
            agricola.edad_cultivo || "";
          worksheet.getCell(`CM${startRow}`).value =
            agricola.etapa_fenologica_cultivo || "";

          //capacidades servicios

          //2. INFRAESTRUCTURA PRODUCTIVA

          const respuestas_almacenamiento_infraestructura =
            (agricola.respuestas_almacenamiento_infraestructura || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CN${startRow}`).value =
            respuestas_almacenamiento_infraestructura.nivel_aplicacion || "";
          worksheet.getCell(`CO${startRow}`).value =
            respuestas_almacenamiento_infraestructura.observaciones || "";

          //
          const respuestas_espacio_bioinsumos =
            (agricola.respuestas_espacio_bioinsumos || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CP${startRow}`).value =
            respuestas_espacio_bioinsumos.nivel_aplicacion || "";
          worksheet.getCell(`CQ${startRow}`).value =
            respuestas_espacio_bioinsumos.observaciones || "";

          worksheet.getCell(`CS${startRow}`).value =
            item.detalle.capacidades_servicios?.seleccion_indicador?.nombre_indicador?.join(
              ", "
            ) || "";

          //
          const respuestas_espacio_dosificacion_mezclas =
            (agricola.respuestas_espacio_dosificacion_mezclas || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CR${startRow}`).value =
            respuestas_espacio_dosificacion_mezclas.nivel_aplicacion || "";
          worksheet.getCell(`CS${startRow}`).value =
            respuestas_espacio_dosificacion_mezclas.observaciones || "";

          //
          const respuestas_reservorio_agua =
            (agricola.respuestas_reservorio_agua || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CT${startRow}`).value =
            respuestas_reservorio_agua.nivel_aplicacion || "";
          worksheet.getCell(`CU${startRow}`).value =
            respuestas_reservorio_agua.observaciones || "";

          //
          const respuestas_tutorado_tipo =
            (agricola.respuestas_tutorado_tipo || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CV${startRow}`).value =
            respuestas_tutorado_tipo.nivel_aplicacion || "";
          worksheet.getCell(`CW${startRow}`).value =
            respuestas_tutorado_tipo.observaciones || "";

          //
          const respuestas_infraestructura_cafe_cacao =
            (agricola.respuestas_infraestructura_cafe_cacao || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CX${startRow}`).value =
            respuestas_infraestructura_cafe_cacao.nivel_aplicacion || "";
          worksheet.getCell(`CY${startRow}`).value =
            respuestas_infraestructura_cafe_cacao.observaciones || "";

          //
          const respuestas_paseras_secado =
            (agricola.respuestas_paseras_secado || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`CZ${startRow}`).value =
            respuestas_paseras_secado.nivel_aplicacion || "";
          worksheet.getCell(`DA${startRow}`).value =
            respuestas_paseras_secado.observaciones || "";

          //
          const respuestas_infraestructura_postcosecha =
            (agricola.respuestas_infraestructura_postcosecha || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DB${startRow}`).value =
            respuestas_infraestructura_postcosecha.nivel_aplicacion || "";
          worksheet.getCell(`DC${startRow}`).value =
            respuestas_infraestructura_postcosecha.observaciones || "";

          //
          const respuestas_vivero =
            (agricola.respuestas_vivero || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DD${startRow}`).value =
            respuestas_vivero.nivel_aplicacion || "";
          worksheet.getCell(`DE${startRow}`).value =
            respuestas_vivero.observaciones || "";

          //
          const respuestas_compostera =
            (agricola.respuestas_compostera || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DF${startRow}`).value =
            respuestas_compostera.nivel_aplicacion || "";
          worksheet.getCell(`DG${startRow}`).value =
            respuestas_compostera.observaciones || "";

          //
          const respuestas_instalaciones_accesibles =
            (agricola.respuestas_instalaciones_accesibles || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DH${startRow}`).value =
            respuestas_instalaciones_accesibles.nivel_aplicacion || "";
          worksheet.getCell(`DI${startRow}`).value =
            respuestas_instalaciones_accesibles.observaciones || "";

          //3. MAQUINARIA, EQUIPOS , HERRAMIENTAS
          const lista_maquinaria_equipo =
            agricola.lista_maquinaria_equipo || [];
          const listaFiltrada_lista_maquinaria_equipo =
            lista_maquinaria_equipo.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_maquinaria_equipo.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_maquinaria_equipo.forEach((item) => {
              worksheet.getCell(`DJ${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`DK${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`DL${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //4. USO Y MANEJO ADECUADO DEL SUELO Y LA FERTILIZACIÓN

          //
          const respuestas_cuenta_analisis_suelo =
            (agricola.respuestas_cuenta_analisis_suelo || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DM${startRow}`).value =
            respuestas_cuenta_analisis_suelo.nivel_aplicacion || "";
          worksheet.getCell(`DN${startRow}`).value =
            respuestas_cuenta_analisis_suelo.observaciones || "";

          //
          const respuestas_cuenta_analisis_suelo_fertilizacion =
            (
              agricola.respuestas_cuenta_analisis_suelo_fertilizacion || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`DO${startRow}`).value =
            respuestas_cuenta_analisis_suelo_fertilizacion.nivel_aplicacion ||
            "";
          worksheet.getCell(`DP${startRow}`).value =
            respuestas_cuenta_analisis_suelo_fertilizacion.observaciones || "";

          worksheet.getCell(`DQ${startRow}`).value =
            agricola.fertiliza_cultivos || "";

          const lista_tipo_insumos_fertiliza =
            agricola.lista_tipo_insumos_fertiliza || [];
          const listaFiltrada_lista_tipo_insumos_fertiliza =
            lista_tipo_insumos_fertiliza.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_tipo_insumos_fertiliza.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_tipo_insumos_fertiliza.forEach((item) => {
              worksheet.getCell(`DR${currentRow}`).value =
                item.tipo_insumo_fertilizacion || "";
              worksheet.getCell(`DS${currentRow}`).value = item.cuales || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const respuestas_enmiendas =
            (agricola["respuestas_enmiendas al suelo"] || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DT${startRow}`).value =
            respuestas_enmiendas.nivel_aplicacion || "";
          worksheet.getCell(`DU${startRow}`).value =
            respuestas_enmiendas.observaciones || "";

          //
          const respuestas_siembra_curvas_nivel =
            (agricola.respuestas_siembra_curvas_nivel || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DV${startRow}`).value =
            respuestas_siembra_curvas_nivel.nivel_aplicacion || "";
          worksheet.getCell(`DW${startRow}`).value =
            respuestas_siembra_curvas_nivel.observaciones || "";

          //
          const lista_actividades_manejo_terreno =
            agricola.lista_actividades_manejo_terreno || [];
          const listaFiltrada_lista_actividades_manejo_terreno =
            lista_actividades_manejo_terreno.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_actividades_manejo_terreno.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_actividades_manejo_terreno.forEach((item) => {
              worksheet.getCell(`DX${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`DY${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`DZ${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const respuestas_uso_compostaje_acondicionamiento =
            (agricola.respuestas_uso_compostaje_acondicionamiento || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EA${startRow}`).value =
            respuestas_uso_compostaje_acondicionamiento.nivel_aplicacion || "";
          worksheet.getCell(`EB${startRow}`).value =
            respuestas_uso_compostaje_acondicionamiento.observaciones || "";

          worksheet.getCell(`EC${startRow}`).value =
            agricola.observaciones_uso_manejo_suelo || "";

          //5. SIEMBRA
          worksheet.getCell(`ED${startRow}`).value =
            agricola.tipo_material_vegetal_siembra || "";

          //
          const lista_acciones_manejo_semillas =
            agricola.lista_acciones_manejo_semillas || [];
          const listaFiltrada_lista_acciones_manejo_semillas =
            lista_acciones_manejo_semillas.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_acciones_manejo_semillas.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_acciones_manejo_semillas.forEach((item) => {
              worksheet.getCell(`EE${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`EF${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`EG${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const respuestas_metodos_germinacion_semillas =
            (agricola.respuestas_metodos_germinacion_semillas || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EH${startRow}`).value =
            respuestas_metodos_germinacion_semillas.nivel_aplicacion || "";
          worksheet.getCell(`EI${startRow}`).value =
            respuestas_metodos_germinacion_semillas.observaciones || "";

          //
          const respuestas_siembras_escalonadas =
            (agricola.respuestas_siembras_escalonadas || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EJ${startRow}`).value =
            respuestas_siembras_escalonadas.nivel_aplicacion || "";
          worksheet.getCell(`EK${startRow}`).value =
            respuestas_siembras_escalonadas.observaciones || "";

          //
          const respuestas_variedad_clon_sembrado =
            (agricola.respuestas_variedad_clon_sembrado || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EL${startRow}`).value =
            respuestas_variedad_clon_sembrado.nivel_aplicacion || "";
          worksheet.getCell(`EM${startRow}`).value =
            respuestas_variedad_clon_sembrado.observaciones || "";

          //
          const respuestas_distancia_siembra =
            (agricola.respuestas_distancia_siembra || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EN${startRow}`).value =
            respuestas_distancia_siembra.nivel_aplicacion || "";
          worksheet.getCell(`EO${startRow}`).value =
            respuestas_distancia_siembra.observaciones || "";

          //
          const respuestas_metodos_recomendaciones_siembra =
            (agricola.respuestas_metodos_recomendaciones_siembra || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`EP${startRow}`).value =
            respuestas_metodos_recomendaciones_siembra.nivel_aplicacion || "";
          worksheet.getCell(`EQ${startRow}`).value =
            respuestas_metodos_recomendaciones_siembra.observaciones || "";

          //
          const respuestas_especies_nativas_siembra =
            (agricola.respuestas_especies_nativas_siembra || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`ER${startRow}`).value =
            respuestas_especies_nativas_siembra.nivel_aplicacion || "";
          worksheet.getCell(`ES${startRow}`).value =
            respuestas_especies_nativas_siembra.observaciones || "";

          //
          const respuestas_intercambio_semillas =
            (agricola.respuestas_intercambio_semillas || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`ET${startRow}`).value =
            respuestas_intercambio_semillas.nivel_aplicacion || "";
          worksheet.getCell(`EU${startRow}`).value =
            respuestas_intercambio_semillas.observaciones || "";

          worksheet.getCell(`EV${startRow}`).value =
            agricola.observaciones_siembra || "";

          //6. MANEJO INTEGRADO DE PLAGAS Y ENFERMEDADES y OTRAS LABORES
          //
          const respuestas_desyerbas_plateos_conservacionistas =
            (
              agricola.respuestas_desyerbas_plateos_conservacionistas || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`EW${startRow}`).value =
            respuestas_desyerbas_plateos_conservacionistas.nivel_aplicacion ||
            "";
          worksheet.getCell(`EX${startRow}`).value =
            respuestas_desyerbas_plateos_conservacionistas.observaciones || "";

          //
          const respuestas_metodos_prevencion_control_enfermedades =
            (
              agricola.respuestas_metodos_prevencion_control_enfermedades || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`EY${startRow}`).value =
            respuestas_metodos_prevencion_control_enfermedades.nivel_aplicacion ||
            "";
          worksheet.getCell(`EZ${startRow}`).value =
            respuestas_metodos_prevencion_control_enfermedades.observaciones ||
            "";

          //
          const respuestas_metodos_prevencion_control_plagas =
            (agricola.respuestas_metodos_prevencion_control_plagas || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FA${startRow}`).value =
            respuestas_metodos_prevencion_control_plagas.nivel_aplicacion || "";
          worksheet.getCell(`FB${startRow}`).value =
            respuestas_metodos_prevencion_control_plagas.observaciones || "";

          //
          const respuestas_practicas_culturales_manejo_sanitario =
            (
              agricola.respuestas_practicas_culturales_manejo_sanitario || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`FC${startRow}`).value =
            respuestas_practicas_culturales_manejo_sanitario.nivel_aplicacion ||
            "";
          worksheet.getCell(`FD${startRow}`).value =
            respuestas_practicas_culturales_manejo_sanitario.observaciones ||
            "";

          //
          const respuestas_realiza_aportes =
            (agricola.respuestas_realiza_aportes || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FE${startRow}`).value =
            respuestas_realiza_aportes.nivel_aplicacion || "";
          worksheet.getCell(`FF${startRow}`).value =
            respuestas_realiza_aportes.observaciones || "";

          //
          const respuestas_intercambio_semillas_manejo_cultural =
            (
              agricola.respuestas_intercambio_semillas_manejo_cultural || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`FG${startRow}`).value =
            respuestas_intercambio_semillas_manejo_cultural.nivel_aplicacion ||
            "";
          worksheet.getCell(`FH${startRow}`).value =
            respuestas_intercambio_semillas_manejo_cultural.observaciones || "";

          worksheet.getCell(`FI${startRow}`).value =
            agricola.observaciones_manejo_cultural || "";

          //7. COSECHA Y POSCOSECHA

          //
          const respuestas_cosecha_momento_adecuado =
            (agricola.respuestas_cosecha_momento_adecuado || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FJ${startRow}`).value =
            respuestas_cosecha_momento_adecuado.nivel_aplicacion || "";
          worksheet.getCell(`FK${startRow}`).value =
            respuestas_cosecha_momento_adecuado.observaciones || "";

          //
          const respuestas_herramientas_adecuadas_cosecha =
            (agricola.respuestas_herramientas_adecuadas_cosecha || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FL${startRow}`).value =
            respuestas_herramientas_adecuadas_cosecha.nivel_aplicacion || "";
          worksheet.getCell(`FM${startRow}`).value =
            respuestas_herramientas_adecuadas_cosecha.observaciones || "";

          //
          const respuestas_tecnicas_adecuadas_recoleccion =
            (agricola.respuestas_tecnicas_adecuadas_recoleccion || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FN${startRow}`).value =
            respuestas_tecnicas_adecuadas_recoleccion.nivel_aplicacion || "";
          worksheet.getCell(`FO${startRow}`).value =
            respuestas_tecnicas_adecuadas_recoleccion.observaciones || "";

          //
          const respuestas_sitio_adecuado_almacenamiento_cosecha =
            (
              agricola.respuestas_sitio_adecuado_almacenamiento_cosecha || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`FP${startRow}`).value =
            respuestas_sitio_adecuado_almacenamiento_cosecha.nivel_aplicacion ||
            "";
          worksheet.getCell(`FQ${startRow}`).value =
            respuestas_sitio_adecuado_almacenamiento_cosecha.observaciones ||
            "";

          //
          const lista_destino_cosecha = agricola.lista_destino_cosecha || [];
          const listaFiltrada_lista_destino_cosecha =
            lista_destino_cosecha.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_destino_cosecha.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_destino_cosecha.forEach((item) => {
              worksheet.getCell(`FR${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`FS${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`FT${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const respuestas_intercambio_alimentos_familiar_comunitario =
            (
              agricola.respuestas_intercambio_alimentos_familiar_comunitario ||
              []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`FU${startRow}`).value =
            respuestas_intercambio_alimentos_familiar_comunitario.nivel_aplicacion ||
            "";
          worksheet.getCell(`FV${startRow}`).value =
            respuestas_intercambio_alimentos_familiar_comunitario.observaciones ||
            "";

          worksheet.getCell(`FW${startRow}`).value =
            agricola.observaciones_cosecha_poscosecha || "";

          //8. MANEJO DE RESIDUOS

          //
          const respuestas_generacion_residuos_unidad_productiva =
            (
              agricola.respuestas_generacion_residuos_unidad_productiva || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`FX${startRow}`).value =
            respuestas_generacion_residuos_unidad_productiva.nivel_aplicacion ||
            "";
          worksheet.getCell(`FY${startRow}`).value =
            respuestas_generacion_residuos_unidad_productiva.observaciones ||
            "";

          //
          const respuestas_manejo_aguas_mieles_cafe_cacao =
            (agricola.respuestas_manejo_aguas_mieles_cafe_cacao || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`FZ${startRow}`).value =
            respuestas_manejo_aguas_mieles_cafe_cacao.nivel_aplicacion || "";
          worksheet.getCell(`GA${startRow}`).value =
            respuestas_manejo_aguas_mieles_cafe_cacao.observaciones || "";

          //
          const lista_tipo_manejo_residuos =
            agricola.lista_tipo_manejo_residuos || [];
          const listaFiltrada_lista_tipo_manejo_residuos =
            lista_tipo_manejo_residuos.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_tipo_manejo_residuos.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_tipo_manejo_residuos.forEach((item) => {
              worksheet.getCell(`GB${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`GC${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`GD${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const lista_tipo_practica_utiliza_residuos =
            agricola.lista_tipo_practica_utiliza_residuos || [];
          const listaFiltrada_lista_tipo_practica_utiliza_residuos =
            lista_tipo_practica_utiliza_residuos.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_tipo_practica_utiliza_residuos.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_tipo_practica_utiliza_residuos.forEach(
              (item) => {
                worksheet.getCell(`GE${currentRow}`).value = item.tipo || "";
                worksheet.getCell(`GF${currentRow}`).value =
                  item.nivel_aplicacion || "";
                worksheet.getCell(`GG${currentRow}`).value =
                  item.observaciones || "";
                currentRow++;
              }
            );
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const lista_principan_fuente_agua =
            agricola.lista_principan_fuente_agua || [];
          const listaFiltrada_lista_principan_fuente_agua =
            lista_principan_fuente_agua.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_principan_fuente_agua.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_principan_fuente_agua.forEach((item) => {
              worksheet.getCell(`GH${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`GI${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`GJ${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          // Capacidades agricola
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_agricola?.calificacion || {},
            [
              "GK",
              "GL",
              "GM",
              "GN",
              "GO",
              "GP",
              "GQ",
              "GR",
              "GS",
              "GT",
              "GU",
              "GV",
              "GW",
              "GX",
              "GY",
              "GZ",
              "HA",
              "HB",
              "HC",
              "HD",
            ],
            [
              "1.1",
              "1.2",
              "1.3",
              "1.4",
              "1.5",
              "2.1",
              "2.2",
              "3.1",
              "4.1",
              "4.2",
              "4.3",
              "5.1",
              "5.2",
              "5.3",
              "6.1",
              "6.2",
              "7.1",
              "7.2",
              "7.3",
              "7.4",
            ]
          );

          //INDICADORES PRODUCTIVOS AGRÍCOLAS

          worksheet.getCell(`HE${startRow}`).value =
            item?.detalle?.capacidades_agricola?.seleccion_indicador?.nombre_indicador?.indicadores_productivos_agricolas?.join(
              ", "
            ) || "";
          worksheet.getCell(`HF${startRow}`).value =
            item?.detalle?.capacidades_agricola?.seleccion_indicador?.nombre_indicador?.indicadores_ambientales?.join(
              ", "
            ) || "";

          worksheet.getCell(`HG${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.transicion_agroecologia?.join(
              ", "
            ) || "";
          worksheet.getCell(`HH${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.proteccion_restauracion_ecosistemas?.join(
              ", "
            ) || "";
          worksheet.getCell(`HI${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.gestion_sostenible_agua?.join(
              ", "
            ) || "";
          worksheet.getCell(`HJ${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.manejo_integral_cultivo?.join(
              ", "
            ) || "";
          worksheet.getCell(`HK${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.salud_suelo?.join(
              ", "
            ) || "";
          worksheet.getCell(`HL${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.cosecha_postcosecha?.join(
              ", "
            ) || "";
          worksheet.getCell(`HM${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.diversificacion_productiva_soberania_alimentaria?.join(
              ", "
            ) || "";
          worksheet.getCell(`HN${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.manejo_residuos_energias_alternativas?.join(
              ", "
            ) || "";
          worksheet.getCell(`HO${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral?.buenas_practicas_agricolas?.join(
              ", "
            ) || "";
          worksheet.getCell(`HP${startRow}`).value =
            item?.detalle?.capacidades_agricola?.acompanamiento_integral
              ?.otros_temas_necesarios || "";

          // PASO 8 - DISPONIBILIDAD DE INFORMACIÓN
          worksheet.getCell(`HQ${startRow}`).value =
            item?.detalle?.recibio_capacitacion_temas_relacionados || "";
          worksheet.getCell(`HR${startRow}`).value =
            item?.detalle?.en_que_temas_capacitado || "";
          worksheet.getCell(`HS${startRow}`).value =
            item?.detalle?.en_que_temas_gustaria_capacitarse || "";
          worksheet.getCell(`HT${startRow}`).value =
            item?.detalle
              ?.disponibilidad_tiempo_participar_procesos_formacion || "";
          worksheet.getCell(`HU${startRow}`).value =
            item?.detalle?.dispositivos_cuenta?.join(", ") || "";
          worksheet.getCell(`HV${startRow}`).value =
            item?.detalle?.tiene_acceso_internet || "";
          worksheet.getCell(`HW${startRow}`).value =
            item?.detalle?.tomara_registro_fotografico || "";
          worksheet.getCell(`HX${startRow}`).value =
            item?.detalle?.numero_fotografias || "";

          // Obtener descripciones de categorías y productos
          try {
            const result = await obtenerDescribcionesCategoriasYproductos(
              item?.detalle?.lista_productos_fortalecimiento_economico
            );
            if (result.length > 0) {
              currentRow = startRow; // Fila de inicio para esta entrada
              result.forEach((producto, index) => {
                worksheet.getCell(`HY${currentRow}`).value =
                  producto?.categoria || "";
                worksheet.getCell(`HZ${currentRow}`).value = Array.isArray(
                  producto?.productos
                )
                  ? producto.productos.join(", ")
                  : "";
                currentRow++; // Avanzar a la siguiente fila
              });

              maxRow = Math.max(maxRow, currentRow);
            } else {
              maxRow = Math.max(maxRow, startRow + 1);
            }
          } catch (error) {
            console.error(
              `Error al obtener descripciones en fila ${startRow}:`,
              error
            );
          }

          worksheet.getCell(`IA${startRow}`).value =
            item?.detalle?.observaciones_recomendaciones || "";
          worksheet.getCell(`IB${startRow}`).value =
            item?.detalle?.fuente || "";
          worksheet.getCell(`IC${startRow}`).value = item?.name || "";
          worksheet.getCell(`ID${startRow}`).value = item?.email || "";
          worksheet.getCell(`IE${startRow}`).value = item?.estado || "";
          worksheet.getCell(`IF${startRow}`).value =
            item?.detalle?.departamento || "";
          worksheet.getCell(`IG${startRow}`).value =
            item?.detalle?.municipio || "";

          for (let row = startRow; row <= maxRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }

          currentRow = maxRow;
        }
      };

      const procesarHojaPecuaria = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }
        let currentRow = 5; // Fila inicial

        for (const item of data) {
          const startRow = currentRow; // Fila de inicio para esta entrada
          let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada
          llenarColumnasComunes(worksheet, item, startRow);

          const pecuario = item.detalle.pecuario || {};

          worksheet.getCell(`BW${startRow}`).value =
            pecuario.area_produccion || "";
          worksheet.getCell(`BX${startRow}`).value =
            pecuario.area_conservacion || "";
          worksheet.getCell(`BY${startRow}`).value = pecuario.area_predio || "";
          worksheet.getCell(`BZ${startRow}`).value =
            pecuario.numero_animales_produccion || "";
          worksheet.getCell(`CA${startRow}`).value =
            pecuario.epoca_lluvia_meses?.join(", ") || "";
          worksheet.getCell(`CB${startRow}`).value =
            pecuario.manejo_registros || "";

          // Comercialización
          const listaComercializacion = pecuario.lista_comercializacion || [];
          if (listaComercializacion.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaComercializacion.forEach((comercializacion) => {
              worksheet.getCell(`CC${currentRow}`).value =
                comercializacion.producto || "";
              worksheet.getCell(`CD${currentRow}`).value =
                comercializacion.cantidad_mes_ano || "";
              worksheet.getCell(`CE${currentRow}`).value =
                comercializacion.venta_unidad || "";
              worksheet.getCell(`CF${currentRow}`).value =
                comercializacion.cliente || "";
              currentRow++; // Avanzar fila solo si hay comercialización
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //PRIMERA PARTE. IDENTIFICACIÓN DE INFRAESTRUCTURA, EQUIPOS, TÉCNICAS Y PRÁCTICAS DE MANEJO SOSTENIBLE
          const lista_sistema_productivo_tiene =
            pecuario.lista_sistema_productivo_tiene || [];
          const listaFiltrada_lista_sistema_productivo_tiene =
            lista_sistema_productivo_tiene.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_sistema_productivo_tiene.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_sistema_productivo_tiene.forEach((item) => {
              worksheet.getCell(`CG${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CH${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CI${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const lista_infraestructura_predio =
            pecuario.lista_infraestructura_predio || [];
          const listaFiltrada_lista_infraestructura_predio =
            lista_infraestructura_predio.filter(
              (item) => item !== null && item !== undefined
            );

          if (listaFiltrada_lista_infraestructura_predio.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_infraestructura_predio.forEach((item) => {
              worksheet.getCell(`CJ${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CK${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CL${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //
          const lista_maquinaria_equipo =
            pecuario.lista_maquinaria_equipo || [];
          const listaFiltrada_lista_maquinaria_equipo =
            lista_maquinaria_equipo.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_maquinaria_equipo.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_maquinaria_equipo.forEach((item) => {
              worksheet.getCell(`CM${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CN${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CO${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //

          const lista_comina_proporciona_animales =
            pecuario.lista_comina_proporciona_animales || [];
          const listaFiltrada_lista_comina_proporciona_animales =
            lista_comina_proporciona_animales.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_comina_proporciona_animales.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_comina_proporciona_animales.forEach((item) => {
              worksheet.getCell(`CP${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CQ${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CR${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          worksheet.getCell(`CS${startRow}`).value =
            pecuario.tipo_suplemento_porcentaje || "";

          const lista_suplemmentacion_alimentaria =
            pecuario.lista_suplemmentacion_alimentaria || [];
          const listaFiltrada_lista_suplemmentacion_alimentaria =
            lista_suplemmentacion_alimentaria.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_suplemmentacion_alimentaria.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_suplemmentacion_alimentaria.forEach((item) => {
              worksheet.getCell(`CT${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CU${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CV${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          const lista_pastos_corte = pecuario.lista_pastos_corte || [];
          const listaFiltrada_lista_pastos_corte = lista_pastos_corte.filter(
            (item) => item && typeof item === "object"
          );

          if (listaFiltrada_lista_pastos_corte.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_pastos_corte.forEach((item) => {
              worksheet.getCell(`CW${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`CX${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`CY${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          ///
          const lista_practicas_manejo_pasturas =
            pecuario.lista_practicas_manejo_pasturas || [];
          const listaFiltrada_lista_practicas_manejo_pasturas =
            lista_practicas_manejo_pasturas.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_practicas_manejo_pasturas.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_practicas_manejo_pasturas.forEach((item) => {
              worksheet.getCell(`CZ${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`DA${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`DB${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          worksheet.getCell(`DC${startRow}`).value =
            pecuario.especies_graminea_leguminsas || "";

          //6. MANEJO SANITARIO Y REPRODUCTIVO

          const respuestas_plan_manejo_reproductivo =
            (pecuario.respuestas_plan_manejo_reproductivo || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DD${startRow}`).value =
            respuestas_plan_manejo_reproductivo.nivel_aplicacion || "";
          worksheet.getCell(`DE${startRow}`).value =
            respuestas_plan_manejo_reproductivo.observaciones || "";

          //
          const respuestas_plan_manejo_sanitario =
            (pecuario.respuestas_plan_manejo_sanitario || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DF${startRow}`).value =
            respuestas_plan_manejo_sanitario.nivel_aplicacion || "";
          worksheet.getCell(`DG${startRow}`).value =
            respuestas_plan_manejo_sanitario.observaciones || "";

          //

          const respuestas_medicamentos_tratamiento =
            (pecuario.respuestas_medicamentos_tratamiento || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DH${startRow}`).value =
            respuestas_medicamentos_tratamiento.nivel_aplicacion || "";
          worksheet.getCell(`DI${startRow}`).value =
            respuestas_medicamentos_tratamiento.observaciones || "";

          //

          const respuestas_lleva_registro_aplicacion =
            (pecuario.respuestas_lleva_registro_aplicacion || []).find(
              (item) => item && typeof item === "object"
            ) || {};

          worksheet.getCell(`DJ${startRow}`).value =
            respuestas_lleva_registro_aplicacion.nivel_aplicacion || "";
          worksheet.getCell(`DK${startRow}`).value =
            respuestas_lleva_registro_aplicacion.observaciones || "";

          //7. MANEJO DE RESIDUOS ORGÁNICOS

          const respuestas_unidades_productivas_generan_residuo_organico =
            (
              pecuario.respuestas_unidades_productivas_generan_residuo_organico ||
              []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`DL${startRow}`).value =
            respuestas_unidades_productivas_generan_residuo_organico.nivel_aplicacion ||
            "";
          worksheet.getCell(`DM${startRow}`).value =
            respuestas_unidades_productivas_generan_residuo_organico.observaciones ||
            "";

          const lista_tipo_manejo_residuos_organicos =
            pecuario.lista_tipo_manejo_residuos_organicos || [];
          const listaFiltrada_lista_tipo_manejo_residuos_organicos =
            lista_tipo_manejo_residuos_organicos.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_tipo_manejo_residuos_organicos.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_tipo_manejo_residuos_organicos.forEach(
              (item) => {
                worksheet.getCell(`DN${currentRow}`).value = item.tipo || "";
                worksheet.getCell(`DO${currentRow}`).value =
                  item.nivel_aplicacion || "";
                worksheet.getCell(`DP${currentRow}`).value =
                  item.observaciones || "";
                currentRow++;
              }
            );
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          const lista_tipo_practica_utiliza_residuos_organicos =
            pecuario.lista_tipo_practica_utiliza_residuos_organicos || [];
          const listaFiltrada_lista_tipo_practica_utiliza_residuos_organicos =
            lista_tipo_practica_utiliza_residuos_organicos.filter(
              (item) => item && typeof item === "object"
            );

          if (
            listaFiltrada_lista_tipo_practica_utiliza_residuos_organicos.length >
            0
          ) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_tipo_practica_utiliza_residuos_organicos.forEach(
              (item) => {
                worksheet.getCell(`DQ${currentRow}`).value = item.tipo || "";
                worksheet.getCell(`DR${currentRow}`).value =
                  item.nivel_aplicacion || "";
                worksheet.getCell(`DS${currentRow}`).value =
                  item.observaciones || "";
                currentRow++;
              }
            );
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          //8. USO ADECUADO DE AGUA PARA CONSUMO ANIMAL

          const lista_principal_fuente_agua =
            pecuario.lista_principal_fuente_agua || [];
          const listaFiltrada_lista_principal_fuente_agua =
            lista_principal_fuente_agua.filter(
              (item) => item && typeof item === "object"
            );

          if (listaFiltrada_lista_principal_fuente_agua.length > 0) {
            currentRow = startRow; // Fila de inicio para esta entrada
            listaFiltrada_lista_principal_fuente_agua.forEach((item) => {
              worksheet.getCell(`DT${currentRow}`).value = item.tipo || "";
              worksheet.getCell(`DU${currentRow}`).value =
                item.nivel_aplicacion || "";
              worksheet.getCell(`DV${currentRow}`).value =
                item.observaciones || "";
              currentRow++;
            });
            maxRow = Math.max(maxRow, currentRow);
          } else {
            maxRow = Math.max(maxRow, startRow + 1);
          }

          const respuestas_sistema_abastecimiento_para_animales =
            (
              pecuario.respuestas_sistema_abastecimiento_para_animales || []
            ).find((item) => item && typeof item === "object") || {};

          worksheet.getCell(`DW${startRow}`).value =
            respuestas_sistema_abastecimiento_para_animales.nivel_aplicacion ||
            "";
          worksheet.getCell(`DX${startRow}`).value =
            respuestas_sistema_abastecimiento_para_animales.observaciones || "";

          //CAPACIDADES DE PECUARIA
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_pecuario?.calificacion || {},
            [
              "DY",
              "DZ",
              "EA",
              "EB",
              "EC",
              "ED",
              "EE",
              "EF",
              "EG",
              "EH",
              "EI",
              "EJ",
              "EK",
              "EL",
              "EM",
              "EN",
              "EO",
              "EP",
              "EQ",
            ],
            [
              "1.1",
              "1.2",
              "2.1",
              "3.1",
              "4.1",
              "5.1",
              "5.2",
              "5.3",
              "5.4",
              "6.1",
              "7.1",
              "7.2",
              "8.1",
              "9.1",
              "10.1",
              "10.2",
              "10.3",
              "10.4",
              "10.5",
            ]
          );

          worksheet.getCell(`ER${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.seleccion_indicador?.nombre_indicador?.join(
              ", "
            ) || "";

          worksheet.getCell(`ES${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.planificacion_predial?.join(
              ", "
            ) || "";
          worksheet.getCell(`ET${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.restauracion_ecosistema?.join(
              ", "
            ) || "";
          worksheet.getCell(`EU${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.gestion_sostenible_agua?.join(
              ", "
            ) || "";
          worksheet.getCell(`EV${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.manejo_adecuado_optimizacion_forrajes?.join(
              ", "
            ) || "";
          worksheet.getCell(`EW${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.manejo_animal_alimentacion?.join(
              ", "
            ) || "";
          worksheet.getCell(`EX${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.manejo_reproductivo?.join(
              ", "
            ) || "";
          worksheet.getCell(`EY${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.salud_suelo?.join(
              ", "
            ) || "";
          worksheet.getCell(`EZ${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.costos_produccion?.join(
              ", "
            ) || "";
          worksheet.getCell(`FA${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.diversificacion_productiva?.join(
              ", "
            ) || "";
          worksheet.getCell(`FB${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.manejo_residuos_anergias_alternativas?.join(
              ", "
            ) || "";
          worksheet.getCell(`FC${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.bpig_ica?.join(
              ", "
            ) || "";
          worksheet.getCell(`FD${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.bpo?.join(
              ", "
            ) || "";
          worksheet.getCell(`FE${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.produccion_alimentos_peletizados?.join(
              ", "
            ) || "";
          worksheet.getCell(`FF${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral?.trazabilidad_sistemas_informacion?.join(
              ", "
            ) || "";
          worksheet.getCell(`FG${startRow}`).value =
            item?.detalle?.capacidades_pecuario?.acompanamiento_integral
              ?.otros_temas || "";

          // PASO 8 - DISPONIBILIDAD DE INFORMACIÓN
          worksheet.getCell(`FH${startRow}`).value =
            item?.detalle?.recibio_capacitacion_temas_relacionados || "";
          worksheet.getCell(`FI${startRow}`).value =
            item?.detalle?.en_que_temas_capacitado || "";
          worksheet.getCell(`FJ${startRow}`).value =
            item?.detalle?.en_que_temas_gustaria_capacitarse || "";
          worksheet.getCell(`FK${startRow}`).value =
            item?.detalle
              ?.disponibilidad_tiempo_participar_procesos_formacion || "";
          worksheet.getCell(`FL${startRow}`).value =
            item?.detalle?.dispositivos_cuenta?.join(", ") || "";
          worksheet.getCell(`FM${startRow}`).value =
            item?.detalle?.tiene_acceso_internet || "";
          worksheet.getCell(`FN${startRow}`).value =
            item?.detalle?.tomara_registro_fotografico || "";
          worksheet.getCell(`FO${startRow}`).value =
            item?.detalle?.numero_fotografias || "";

          // Obtener descripciones de categorías y productos
          try {
            const result = await obtenerDescribcionesCategoriasYproductos(
              item?.detalle?.lista_productos_fortalecimiento_economico
            );
            if (result.length > 0) {
              currentRow = startRow; // Fila de inicio para esta entrada
              result.forEach((producto, index) => {
                worksheet.getCell(`FP${currentRow}`).value =
                  producto?.categoria || "";
                worksheet.getCell(`FQ${currentRow}`).value = Array.isArray(
                  producto?.productos
                )
                  ? producto.productos.join(", ")
                  : "";
                currentRow++; // Avanzar a la siguiente fila
              });

              maxRow = Math.max(maxRow, currentRow);
            } else {
              maxRow = Math.max(maxRow, startRow + 1);
            }
          } catch (error) {
            console.error(
              `Error al obtener descripciones en fila ${startRow}:`,
              error
            );
          }

          worksheet.getCell(`FR${startRow}`).value =
            item?.detalle?.observaciones_recomendaciones || "";
          worksheet.getCell(`FS${startRow}`).value =
            item?.detalle?.fuente || "";

          worksheet.getCell(`FT${startRow}`).value = item?.name || "";
          worksheet.getCell(`FU${startRow}`).value = item?.email || "";
          worksheet.getCell(`FV${startRow}`).value = item?.estado || "";
          worksheet.getCell(`FW${startRow}`).value =
            item?.detalle?.departamento || "";
          worksheet.getCell(`FX${startRow}`).value =
            item?.detalle?.municipio || "";
          for (let row = startRow; row <= maxRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }
          currentRow = maxRow;
        }
      };

      const procesarHojaServicios = async (worksheet, data) => {
        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No hay datos válidos para procesar servicios:", data);
          return; // Salimos de la función si no hay datos
        }

        let currentRow = 5; // Fila inicial

        for (const item of data) {
          let startRow = currentRow; // Fila de inicio del item

          llenarColumnasComunes(worksheet, item, startRow);

          const servicios = item.detalle.servicios || {};
          worksheet.getCell(`BW${startRow}`).value =
            servicios?.tipo_de_servicio?.join(", ") || "";
          worksheet.getCell(`BX${startRow}`).value =
            servicios?.otro_tipo_de_servicio || "";
          worksheet.getCell(`BY${startRow}`).value =
            servicios?.cuenta_con_equipos_necesarios || "";
          worksheet.getCell(`BZ${startRow}`).value =
            servicios?.estado_equipos || "";
          worksheet.getCell(`CA${startRow}`).value =
            servicios?.frecuencia_mantenimiento_maquinas || "";
          worksheet.getCell(`CB${startRow}`).value =
            servicios?.demanda_servicio_actualmente || "";
          worksheet.getCell(`CC${startRow}`).value =
            servicios?.cuenta_con_espacio_almacenamiento_insumos || "";
          worksheet.getCell(`CD${startRow}`).value =
            servicios?.actividades_realiza_mantenimiento_equipos || "";
          worksheet.getCell(`CE${startRow}`).value =
            servicios?.cuenta_con_elementos_proteccion || "";
          worksheet.getCell(`CF${startRow}`).value =
            servicios?.presentacion_del_servicio || "";
          worksheet.getCell(`CG${startRow}`).value =
            servicios?.como_adquiero_conocimiento_ofrecido?.join(", ") || "";
          worksheet.getCell(`CH${startRow}`).value =
            servicios?.otro_como_adquiero_conocimiento_ofrecido || "";
          worksheet.getCell(`CI${startRow}`).value =
            servicios?.brinda_garantia_servicio || "";
          worksheet.getCell(`CJ${startRow}`).value =
            servicios?.cuenta_portafolio_servicios || "";

          // Capacidades servicios
          asignarCalificaciones(
            worksheet,
            startRow,
            item?.detalle?.capacidades_servicios?.calificacion || {},
            ["CK", "CL", "CM", "CN", "CO", "CP", "CQ", "CR", "CS"],
            ["1.1", "1.2", "2.1", "3.1", "34.1", "5.1", "5.2", "6.1", "7.1"]
          );

          worksheet.getCell(`CT${startRow}`).value =
            item?.detalle?.capacidades_servicios?.seleccion_indicador?.nombre_indicador?.join(
              ", "
            ) || "";

          // PASO 8 - DISPONIBILIDAD DE INFORMACIÓN
          worksheet.getCell(`CU${startRow}`).value =
            item?.detalle?.recibio_capacitacion_temas_relacionados || "";
          worksheet.getCell(`CV${startRow}`).value =
            item?.detalle?.en_que_temas_capacitado || "";
          worksheet.getCell(`CW${startRow}`).value =
            item?.detalle?.en_que_temas_gustaria_capacitarse || "";
          worksheet.getCell(`CX${startRow}`).value =
            item?.detalle
              ?.disponibilidad_tiempo_participar_procesos_formacion || "";
          worksheet.getCell(`CY${startRow}`).value =
            item?.detalle?.dispositivos_cuenta?.join(", ") || "";
          worksheet.getCell(`CZ${startRow}`).value =
            item?.detalle?.tiene_acceso_internet || "";
          worksheet.getCell(`DA${startRow}`).value =
            item?.detalle?.tomara_registro_fotografico || "";
          worksheet.getCell(`DB${startRow}`).value =
            item?.detalle?.numero_fotografias || "";

          // Obtener descripciones de categorías y productos
          try {
            const result = await obtenerDescribcionesCategoriasYproductos(
              item?.detalle?.lista_productos_fortalecimiento_economico
            );
            if (result.length > 0) {
              let rowForProductos = startRow;
              result.forEach((producto, index) => {
                worksheet.getCell(`DC${rowForProductos}`).value =
                  producto?.categoria || "";
                worksheet.getCell(`DD${rowForProductos}`).value = Array.isArray(
                  producto?.productos
                )
                  ? producto.productos.join(", ")
                  : "";
                rowForProductos++; // Avanzar a la siguiente fila
              });

              currentRow = rowForProductos; // Actualizar la siguiente fila de inicio
            } else {
              currentRow++; // Si no hay productos, solo avanzar una fila
            }
          } catch (error) {
            console.error(
              `Error al obtener descripciones en fila ${startRow}:`,
              error
            );
          }

          worksheet.getCell(`DE${startRow}`).value =
            item?.detalle?.observaciones_recomendaciones || "";
          worksheet.getCell(`DF${startRow}`).value = item.detalle.fuente || "";

          worksheet.getCell(`DG${startRow}`).value = item?.name || "";
          worksheet.getCell(`DH${startRow}`).value = item?.email || "";
          worksheet.getCell(`DI${startRow}`).value = item?.estado || "";
          worksheet.getCell(`DJ${startRow}`).value =
            item?.detalle?.departamento || "";
          worksheet.getCell(`DK${startRow}`).value =
            item?.detalle?.municipio || "";
          for (let row = startRow; row <= currentRow; row++) {
            worksheet.getCell(`A${row}`).value =
              item.detalle.id_participante || "";
          }
        }
      };

      const datosAgrupados = groupByLineaProductiva(dataCompleta);

      const datasets = [
        {
          name: "Agrícola",
          data: datosAgrupados.Agrícola,
          processor: procesarHojaAgricola,
        },

        {
          name: "Pecuaria",
          data: datosAgrupados.Pecuaria,
          processor: procesarHojaPecuaria,
        },
        {
          name: "Servicios",
          data: datosAgrupados.Servicios,
          processor: procesarHojaServicios,
        },
      ];

      await Promise.all(
        datasets.map(async ({ name, data, processor }) => {
          let worksheet = workbook.getWorksheet(name);
          if (!worksheet) {
            worksheet = workbook.addWorksheet(name);
          }
          await processor(worksheet, data); // ✅ Ahora espera a que termine cada procesamiento
        })
      );

      // Descargar el archivo modificado
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe_analisis_capacidades.xlsx");
      notification.success({
        message: "Exito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingJson(true);

      // Convertir data a JSON y descargar
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe_analisis_capacidades.json");

      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoadingJson(false);
    }
  };
  return (
    <Space>
      <Tooltip title="Exportar datos en XLSX">
        <Button
          type="default"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loading || loadingExcel}
          disabled={loading || loadingExcel}
          style={{
            backgroundColor: "#52c41a",
            borderColor: "#52c41a",
            color: "white",
          }}
        />
      </Tooltip>

      <Tooltip title="Exportar datos en JSON">
        <Button
          type="default"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loading || loadingJson}
          disabled={loading || loadingJson}
          style={{
            backgroundColor: "#C2BCBC",
            borderColor: "#C2BCBC",
            color: "white",
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default Export_analisisCapacidades;
